export const featureList = [
  // Manage
  {
    description:
      'Automatically creates an AIFF copy of your WAV files, and a WAV copy of your AIFF files.',
  },
  {
    description: 'Ingest back catalog and new releases from your distributor.',
  },
  {
    description:
      'Custom inboxes let you create special inboxes for projects or different types of deliveries.',
  },
  {
    description: 'Extend what metadata you can store with custom fields.',
  },
  {},
  {},
  // Discover
  {
    description:
      'DISCO’s Insights dashboard gives you powerful insights on how your music and files are being used – both by your team and the people you send music to.',
  },
  {
    description:
      'DISCO’s reporting function lets you quickly generate powerful insights on you and your team’s activity in the app. Generate pitch reports, export metadata and more.',
  },
  {},
  // Share
  {},
  {},
  {
    description:
      'Shareable channels let you share larger amounts of music, including whole catalogs.',
  },
  {
    description:
      'Alias metadata lets you control what metadata on your tracks gets shared.',
  },
  {
    description:
      ' The Email Creator lets you easily send great looking email newsletters to lists of any size, like you would on Mailchimp, Campaign Monitor or Constant Contact.',
  },
]
